.events-list .event-details-row {
	box-shadow: rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px;
	border-radius: 2px;
	margin-top: 20px;
}

.events-list .event-details-row:first-child {
	margin-top: 0;
}
